import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';
import { catchError, firstValueFrom, map, of, tap } from 'rxjs';

import { LOGIN_CONFIG_FALLBACK } from './constants/login-config-fallback';
import { ConfigService } from './services/config.service';
import { LoginConfigApiService } from './services/login-config-api.service';

export function provideLoginConfig(
  initialSearch = typeof window !== 'undefined' ? window.location.search : ''
): EnvironmentProviders {
  return makeEnvironmentProviders([
    LoginConfigApiService,
    ConfigService,
    provideAppInitializer(() => {
      const api = inject(LoginConfigApiService);
      const configService = inject(ConfigService);

      return firstValueFrom(
        api.loadConfig().pipe(
          catchError((error: unknown) => {
            faro?.api?.pushError(
              error instanceof Error ? error : new Error(String(error))
            );
            return of(LOGIN_CONFIG_FALLBACK);
          }),
          tap((response) => {
            ConfigService.applyBootstrapConfig(
              configService,
              response,
              new URLSearchParams(initialSearch)
            );
          }),
          map(() => undefined)
        )
      );
    }),
  ]);
}
